import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {LITERAL_NAME_REGEX} from '../models/constants';
import {getLabelParts} from '../util/staged-cohort';
import template from './index.jade';
import css from './index.styl?inline';

export class CohortsExpressionLabel extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      expression: {type: `string`, default: null, description: `StagedCohort.label`},
    };
  }

  get config() {
    return {
      useShadowDom: true,
      css,
      template,
      helpers: {
        getExpressionParts: () => {
          if (!this.attr(`expression`)) {
            return [];
          }

          const parts = getLabelParts(this.attr(`expression`), LITERAL_NAME_REGEX);
          if (parts.length === 1 && parts[0].literal) {
            return [{text: `Group ${parts[0].text}`}];
          } else {
            return parts;
          }
        },
      },
    };
  }
}

export const CohortsExpressionLabelEl = defineAndMakeJsxFactory(`mp-cohorts-expression-label`, CohortsExpressionLabel);
